import type { FanClubPublicSummary } from "@/lib/fan-clubs/types";

/**
 * Keep the cached story page's RSC payload scrape-safe even if a backend query
 * later grows member-only fields. Never pass its source object through intact.
 */
export function toPublicFanClubProps<T extends FanClubPublicSummary>(
  fanClub: T,
): FanClubPublicSummary {
  return {
    id: fanClub.id,
    storyId: fanClub.storyId,
    name: fanClub.name,
    description: fanClub.description,
    status: fanClub.status,
    memberCount: fanClub.memberCount,
  };
}
